import React, { Component, Fragment } from 'react';
import {
  Navbar,
  NavbarBrand,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { MsalContext } from '@azure/msal-react';
import './NavMenu.css';
import SignIn from './Auth/SignIn';
import BuildeTokenBalance from './Profile/BuildeTokenBalance';
import { createThirdwebClient } from "thirdweb";
import { ConnectButton } from "thirdweb/react";
import { createWallet } from "thirdweb/wallets";
import { UserContext } from '../context/User';
import { APPConstants } from '../constants/app';
import MySolutionsNavLink from './Navigation/MySolutionsNavLink';
import Username from './Profile/Username';

export class NavMenu extends Component {
  static displayName = NavMenu.name;
  static contextType = MsalContext;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {
    const authContext = this.context;
    const account = this.context.accounts && this.context.accounts.length > 0
      ? this.context.accounts[0]
      : null;

    const client = createThirdwebClient({ clientId: "7d8e283b142aac1311e7b4794cb1ea0b" });
    const wallets = [createWallet("io.metamask")];

    function Authorization(props) {
      const isLoggedIn = account !== null;

      const handleLogout = () => {
        authContext.instance.logoutPopup({
          postLogoutRedirectUri: APPConstants.APP_BASE_URI,
        }).then(() => {
          props.userContext.setUser({});
        });
      }

      const handleClick = () => {
        alert("NOTE: You are currently connected to the Sepolia testnet, not the Ethereum mainnet. Any transaction will be simulated using test ETH (not real funds). Please confirm you're on the correct network (Sepolia testnet) before proceeding.");
      };

      if (isLoggedIn) {
        return (
          <Fragment>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret className='text-white'>
                <span className='text-white'>
                  <Username/>
                </span>
              </DropdownToggle>
              <DropdownMenu end>
                <DropdownItem tag={Link} to="/my-profile">My Profile</DropdownItem>
                <MySolutionsNavLink/>
                <DropdownItem onClick={handleLogout}>Log Out</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <NavItem>
              <NavLink className='text-white'>
                <span>Token Balance</span>
                <strong>
                  &nbsp;<BuildeTokenBalance />
                </strong>
              </NavLink>              
            </NavItem>
            <NavItem className='align-content-center'>
              <ConnectButton
                connectButton={{
                  className: 'nav-wallet-connect',
                  label: 'Connect Wallet'
                }}
                theme={'light'}
                client={client}
                wallets={wallets}
                connectModal={{ size: "compact" }} 
              />
            </NavItem>
            <NavItem className="testnet-warning d-none" onClick={handleClick}>
                    Please verify that you are connected
                    <br></br>
                    to the Sepolia Testnet.
            </NavItem>
                
          </Fragment>
        );
      }
      return (
        <NavItem>
          <SignIn />
        </NavItem>
      );
    }

    return (
      <header>
        <UserContext.Consumer>
          {(roleContext) => (
            <Navbar
              className={`navbar-expand-sm navbar-toggleable-sm ${roleContext.isHomeowner()
                  ? 'bg-builde-blue' : 'bg-builde-seashell'}`
              } container light>
              <NavbarBrand tag={Link} to={ APPConstants.APP_BASE_URI } className="text-white ms-0">₿UIŁÐΞ</NavbarBrand>
              <div className="d-sm-inline-flex flex-sm-row-reverse me-0">
                <ul className="navbar-nav flex-grow">
                  <Authorization instance={authContext} userContext={roleContext} />
                </ul>
              </div>
            </Navbar>
          )}
        </UserContext.Consumer>
      </header>
    );
  }
}
